import Vue from 'vue';


// Initialize the annoying-background directive.
const PlacesAutocomplete = {
  inserted(el, binding, vnode) {
    // Allow users to customise the color by passing an expression.
    $(function(){
        let input = $(el).find("input")[0]
        input.placeholder = ''

        let autocompleteOptions = {
            types: ['address'],
            componentRestrictions: {country: 'us'}
        }
        $(el).hover(function(){
            $(el).find("input").attr("autocomplete","new-password")
        })
        let autocomplete = new google.maps.places.Autocomplete(input, autocompleteOptions)
        autocomplete.setFields(['address_components'])
        autocomplete.addListener('place_changed', function(){
            
            let place = autocomplete.getPlace()

            /**
             * Callback
             */
            let callback = binding.value
            if(typeof callback === "function"){
                callback(place)
            }
        })
    })
    
    
  }
}

Vue.directive('places-autocomplete', PlacesAutocomplete)


export default PlacesAutocomplete